{
  "nl": {
    "analytics": {
      "labels": {
        "allUnits": "Alle units",
        "click_seen_by": "Klik voor meer informatie",
        "click_shared_with": "Klik om te weten met welke klanten dit gedeeld is",
        "deleted": "Verwijderd",
        "deleted_item": "Dit item is verwijderd en is niet meer klikbaar",
        "noCustomers": "Nog geen klanten toegewezen aan dit niveau",
        "noCustomersSeen": "Nog geen enkele klant heeft dit gezien",
        "noCustomersUnseen": "Alle klanten hebben dit gezien",
        "noUnitAccess": "Geen toegang tot unit",
        "notSeen": "Nog niet gezien ({number})",
        "seen": "Gezien ({number})",
        "seenAt": "Gezien {date}",
        "seenBy": "Gezien door",
        "seen_by_all": "Door iedereen gezien. Klik om te zien wie het heeft gezien.",
        "sharedWithMultipleUnits": "Gedeeld met 0 klanten in {level_name} | Gedeeld met 1 klant in {level_name} | Gedeeld met {customers_count} klanten in {level_name}",
        "sharedWithUnit": "Gedeeld met {unit_name}",
        "units": "Geen Unit | 1 Unit | {count} Units",
        "unseenOfTotal": "{unseen} van {total} hebben het nog niet gezien",
        "views": "Gezien door",
        "viewsCount": "Nog niet gezien | 1 gezien | {count} gezien",
        "whoSeenAnnouncement": "Wie heeft dit nieuwsbericht gezien"
      }
    }
  }
}
